// @mui
import Button from '@mui/material/Button';
// types
import { ReturnType } from 'src/hooks/use-boolean';
// redux
import { useDispatch, useSelector } from 'src/redux/store';
import { resetTaxError } from 'src/redux/slices/tax';
// localization
import { useLocales } from '../../locales';
// components
import { ConfirmDialog } from '../custom-dialog';
import { paths } from '../../routes/paths';

type props = {
  openState?: ReturnType;
  values?: number[];
  handleDismiss?: () => void;
};

export default function TaxConfirm({ openState, values, handleDismiss }: props) {
  const error = useSelector((state) => state.tax.error);

  const dispatch = useDispatch();

  const { t } = useLocales();

  const handleEdit = () => {
    window.open(
      `${paths.bookkeeping.tax}?id=${values?.join(',') ?? error?.ids?.join(',')}&edit=true`,
      '_blank'
    );
    dispatch(resetTaxError());
  };

  const renderConfirm = (
    <ConfirmDialog
      open={openState?.value ?? error ?? false}
      onClose={() => (handleDismiss && handleDismiss()) ?? dispatch(resetTaxError())}
      title={t('Edit VAT account')}
      content={
        <>
          {error
            ? error.detail
            : t(
                'The added product VAT bracket does not have a assosiated account, would you like to change this?'
              )}
        </>
      }
      action={
        <Button
          variant="contained"
          color="primary"
          onClick={() => {
            handleEdit();
            openState?.onFalse();
          }}
        >
          {t('Edit VAT')}
        </Button>
      }
    />
  );

  return <>{renderConfirm}</>;
}
